/** Kleinster zahlbarer Restbetrag (ein Cent): Beträge bis hierhin gelten als beglichen. */
export const MIN_PAYABLE_AMOUNT = 0.01;
